import TaxonomyItem from "features/taxonomy/components/TaxonomyItem";
import _ from "lodash";
import { useSelector } from "react-redux";
import GenericPopover from "shared/popovers/GenericPopover";
import { GenericButton } from "shared/ui-basics/buttons";
import styled from "styled-components";
import { getTaxonomyColorData } from "utils/helpers";

export const Groups = ({ recordId, allRecordsSelector }) => {
	const parentItem = useSelector((state) => _.get(state, allRecordsSelector) || [])?.find((item) => (item?.id || item?.personaId || item?.cjmId) === recordId);
	const allGroups = useSelector((state) => state.libraries?.group);
	let groupIds = parentItem?.groups;

	const GroupCard = ({ groupId }) => {
		const currentGroup = allGroups?.find((g) => g?.id === groupId) || {};
		const { backgroundColor, color } = getTaxonomyColorData({ entity: "group", colorCode: currentGroup?.colorCode });
		return <TaxonomyItem text={currentGroup?.name} backgroundColor={backgroundColor} color={color} />;
	};

	const custom = (
		<div>
			{groupIds?.slice(2, Infinity).map((groupId) => (
				<div key={groupId} className="mb-1">
					<GroupCard groupId={groupId} />
				</div>
			))}
		</div>
	);
	return (
		<WrapperDiv className="d-flex position-relative">
			{groupIds?.slice(0, 2).map((groupId) => (
				<div key={groupId} className="mb-1 ms-1">
					<GroupCard groupId={groupId} />
				</div>
			))}
			{groupIds?.length > 2 && (
				<div className="ms-1">
					<GenericPopover custom={custom}>
						<GenericButton variant="light" iconClassName="ms-2" size={"xs"} className="p-1">
							+{groupIds?.length - 2}
						</GenericButton>
					</GenericPopover>
				</div>
			)}
		</WrapperDiv>
	);
};
const WrapperDiv = styled.div`
	display: -webkit-box;
	overflow: hidden;
`;

export default Groups;
